import { fromJS } from 'immutable';
import { LOAD_EVENT_SCHEDULES_SUCCESS, DELETE_EVENT_SCHEDULE_SUCCESS } from 'constants/ActionTypes';

const initialState = fromJS({
  pagination: {},
  dataset: [],
});

/**
 * Reducer for EventTemplateTable component
 * @param state
 * @param action
 * @returns {any}
 */
const eventScheduleTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_EVENT_SCHEDULES_SUCCESS: {
      return state.set('dataset', fromJS(action.schedules.items.map((schedule) => schedule.scheduleId))).set(
        'pagination',
        fromJS({
          totalCount: action.schedules._meta.totalCount,
          pageCount: action.schedules._meta.pageCount,
          currentPage: action.schedules._meta.currentPage,
          perPage: action.schedules._meta.perPage,
        }),
      );
    }
    case DELETE_EVENT_SCHEDULE_SUCCESS:
      return state.set(
        'dataset',
        state.get('dataset').filter((scheduleId) => scheduleId !== action.scheduleId),
      );
    default:
      return state;
  }
};

export default eventScheduleTableReducer;
